import React from 'react';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TangModalHeader } from '../components/TangModalHeader';
import { LoginModal, useLoginModalFlow } from '../context/LoginModalFlowContext';
import { ImageModalOrangeCellphone } from '../assets/ImageModalOrangeCellphone';
import { trackLoginEvents } from '../utils/eventTracking';

export function IncorrectDataModal() {
  const { t } = useTranslation('modais');
  
  const modalFlow = useLoginModalFlow();

  function toggleModal() {
    modalFlow.closeModal(LoginModal.INCORRECT_DATA);
    trackLoginEvents.IncorrectDataTryAgain();
  }
  
  return (
    <SmlsModal
      type="right"
      isOpen={modalFlow.isModalOpen(LoginModal.INCORRECT_DATA)}
      className="tang-modal"
      toggle={toggleModal}
      defaultHeader={false}
    >
      <TangModalHeader showCloseButton onClose={toggleModal} />
      <ModalBody data-testid="modal-body">
        <div className="modal-content">
          <div> 
            <div className="modal-icon">
              <ImageModalOrangeCellphone />
            </div>
            <p className="modal-title">{t('acesso_02.title')}</p>
            <p className="modal-subtitle">
              {t('acesso_02.text')}
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className='one-button'>
        <SmlsButton className="button" text={t('acesso_02.button_primary')} onClick={toggleModal} />
      </ModalFooter>
    </SmlsModal>
  );
}
